import React from 'react';
import { getIconClassName } from '@uifabric/styling';
import { MiniIcons } from 'owa-mini-icons';

const styles = require('./MultiSelectCheckbox.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MultiSelectCheckboxProps {
    isSelected?: boolean;
    wrapInContainer?: boolean;
}

export const MultiSelectCheckbox = ({
    isSelected = true,
    wrapInContainer = false,
}: MultiSelectCheckboxProps) => {
    const selectBoxStyles = classNames(styles.selectBox, isSelected && styles.isSelected);

    const children = (
        <>
            <i className={selectBoxStyles} role="checkbox" aria-checked={isSelected}>
                <i className={classNames(styles.circleEmpty, 'ms-Icon')} />
                <i
                    className={classNames(
                        styles.selectCheckContainer,
                        styles.selectCheck,
                        'ms-Icon',
                        getIconClassName(MiniIcons.CheckMark)
                    )}
                />
            </i>
            {isSelected && (
                /**
                 * Using aria-live here instead of the AriaLiveWrapper because here we do not need a custom label to be announced.
                 * We want the change in the ariaSummaryLabel to be announced.
                 */
                <i
                    className={classNames(
                        styles.circleEmpty,
                        styles.showTick,
                        'ms-Icon',
                        getIconClassName(MiniIcons.CheckMark)
                    )}></i>
            )}
        </>
    );

    return wrapInContainer ? <div className={styles.container}>{children}</div> : children;
};
